export const DIAG = 'DIAG';
export const MATRICE = 'MATRICE';
export const FINAL = 'FINAL';

export const ERROR = 'ERROR';